import { useEffect, useMemo, useRef, useState } from 'react'
import { colorToHex, colorToHsvArray, normalizeHexLength } from 'utils'
import { Container, Hue, Value } from './style'

type Props = {
    className?: string
    color?: string
    defaultColor?: string
    disabled?: boolean
    onChange?: (hex: string) => void
}

const ColorPicker = ({ className, color: colorProp, defaultColor = '#f00', disabled = false, onChange }: Props) => {
    const initialValueRef = useRef<string | undefined>(normalizeHexLength(colorProp || defaultColor))
    const defaultHsv = useMemo(() => colorToHsvArray(colorProp || defaultColor), [])
    const [hsv, setHsv] = useState<number[]>(defaultHsv)

    const onHueChange = (hue: number) => {
        setHsv((hsv) => [hue, hsv[1], hsv[2]])
    }

    useEffect(() => {
        if (!colorProp) return

        const colorPropHsv = colorToHsvArray(normalizeHexLength(colorProp))

        setHsv((state) => {
            if (colorPropHsv[0] !== state[0] || colorPropHsv[1] !== state[1] || colorPropHsv[2] !== state[2]) {
                return colorPropHsv
            }

            return state
        })
    }, [colorProp])

    useEffect(() => {
        if (hsv.length < 3) return

        const color = colorToHex(`hsv(${hsv.join(',')})`)

        if (!disabled && color && color !== initialValueRef.current) {
            initialValueRef.current = undefined
            onChange?.(color)
        }
    }, [hsv[0], hsv[1], hsv[2]])

    return (
        <Container className={className} disabled={disabled}>
            <Value hsv={hsv} onChange={setHsv} />
            <Hue hsv={hsv} onChange={onHueChange} />
        </Container>
    )
}

export default ColorPicker
